import React, { FC } from 'react';

import { Modal } from '../../../components/modal/index';

export type DeleteSubscriptionModalProps = {
  companyName?: string;
  isOpen: boolean;
  isPending: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
};

export const DeleteSubscriptionModal: FC<DeleteSubscriptionModalProps> = ({
  isOpen,
  isPending,
  onConfirm,
  onDismiss,
  companyName,
}) => (
  <Modal
    description={
      companyName
        ? `Are you sure you want to delete the subscription offer for ${companyName}? This cannot be undone.`
        : 'Are you sure you want to delete this subscription offer? This cannot be undone.'
    }
    dismissButtonContent="Cancel"
    isOpen={isOpen}
    onDismiss={onDismiss}
    onSuccess={isPending ? undefined : onConfirm}
    successButtonContent={isPending ? 'Deleting…' : 'Delete'}
    title="Delete subscription offer"
  />
);
